/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { AddressFragmentDoc } from '../../../../graphql/fragments/CustomerData.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeliveryPreferenceType = 'CURBSIDE' | 'DOOR' | 'LEAVE_AT_DOOR';

export type OrderType =
  | 'CATERING'
  | 'CATERING_DELIVERY'
  | 'CATERING_PICKUP'
  | 'DELIVERY'
  | 'IN_STORE'
  | 'PICKUP';

export type OrdersInputV2 = {
  readonly includeCanceledOrders?: boolean | null | undefined;
  readonly includePlacedOrders?: boolean | null | undefined;
  readonly page: number;
  readonly take: number;
};

export type OrderForLocationFragment = {
  readonly __typename: 'Order';
  readonly id: string;
  readonly orderType: Types.OrderType;
  readonly dropoffLocation: string | null;
  readonly deliveryOrderDetail: {
    readonly __typename: 'DeliveryOrderDetail';
    readonly id: string;
    readonly estimatedDeliveryTime: string | null;
    readonly deliveryFee: number;
    readonly vendor: string;
    readonly vendorRestaurantId: string;
    readonly address: {
      readonly __typename: 'Address';
      readonly id: string;
      readonly street: string;
      readonly secondaryStreet: string | null;
      readonly name: string | null;
      readonly city: string;
      readonly state: string;
      readonly zipCode: string;
      readonly country: string;
      readonly deliveryPreference: Types.DeliveryPreferenceType;
      readonly googlePlaceId: string;
      readonly latitude: number;
      readonly longitude: number;
      readonly notes: string | null;
    } | null;
  } | null;
};

export type OrderForLocationRestaurantFragment = {
  readonly __typename: 'Restaurant';
  readonly id: string;
  readonly name: string;
  readonly isOutpost: boolean;
  readonly slug: string;
  readonly city: string;
  readonly state: string;
  readonly address: string;
  readonly zipCode: string;
  readonly phone: string;
  readonly flexMessage: string | null;
  readonly isAcceptingOrders: boolean;
  readonly notAcceptingOrdersReason: string;
  readonly latitude: number;
  readonly longitude: number;
  readonly sanitaryGradeDisplayText: string | null;
  readonly sanitaryGradeUrl: string | null;
  readonly hours: { readonly formatted: string | null };
  readonly asset: { readonly url: string };
};

export type OrdersV2ForLocationQueryVariables = Exact<{
  input: Types.OrdersInputV2;
}>;

export type OrdersV2ForLocationQuery = {
  readonly ordersV2:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly dropoffLocation: string | null;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly name: string;
            readonly isOutpost: boolean;
            readonly slug: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly phone: string;
            readonly flexMessage: string | null;
            readonly isAcceptingOrders: boolean;
            readonly notAcceptingOrdersReason: string;
            readonly latitude: number;
            readonly longitude: number;
            readonly sanitaryGradeDisplayText: string | null;
            readonly sanitaryGradeUrl: string | null;
            readonly hours: { readonly formatted: string | null };
            readonly asset: { readonly url: string };
          };
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly estimatedDeliveryTime: string | null;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly vendorRestaurantId: string;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly name: string | null;
              readonly city: string;
              readonly state: string;
              readonly zipCode: string;
              readonly country: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly notes: string | null;
            } | null;
          } | null;
        }>;
      }
    | Record<PropertyKey, never>;
};

export type OrdersV2ForLocationWithDisclosureQueryVariables = Exact<{
  input: Types.OrdersInputV2;
}>;

export type OrdersV2ForLocationWithDisclosureQuery = {
  readonly ordersV2:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly dropoffLocation: string | null;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly showDeliveryPriceDifferenciationDisclosure: boolean;
            readonly showOutpostPriceDifferenciationDisclosure: boolean;
            readonly id: string;
            readonly name: string;
            readonly isOutpost: boolean;
            readonly slug: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly phone: string;
            readonly flexMessage: string | null;
            readonly isAcceptingOrders: boolean;
            readonly notAcceptingOrdersReason: string;
            readonly latitude: number;
            readonly longitude: number;
            readonly sanitaryGradeDisplayText: string | null;
            readonly sanitaryGradeUrl: string | null;
            readonly hours: { readonly formatted: string | null };
            readonly asset: { readonly url: string };
          };
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly estimatedDeliveryTime: string | null;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly vendorRestaurantId: string;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly name: string | null;
              readonly city: string;
              readonly state: string;
              readonly zipCode: string;
              readonly country: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly notes: string | null;
            } | null;
          } | null;
        }>;
      }
    | Record<PropertyKey, never>;
};

export const OrderForLocationFragmentDoc = gql`
  fragment OrderForLocation on Order {
    id
    __typename
    orderType
    deliveryOrderDetail {
      id
      __typename
      address {
        ...address
      }
      estimatedDeliveryTime
      deliveryFee
      vendor
      vendorRestaurantId
    }
    dropoffLocation
  }
  ${AddressFragmentDoc}
`;
export const OrderForLocationRestaurantFragmentDoc = gql`
  fragment OrderForLocationRestaurant on Restaurant {
    id
    __typename
    name
    isOutpost
    slug
    city
    state
    address
    zipCode
    phone
    hours {
      formatted
    }
    asset {
      url
    }
    flexMessage
    isAcceptingOrders
    notAcceptingOrdersReason
    latitude
    longitude
    sanitaryGradeDisplayText
    sanitaryGradeUrl
  }
`;
export const OrdersV2ForLocationDocument = gql`
  query ordersV2ForLocation($input: OrdersInputV2!) {
    ordersV2(input: $input) {
      ... on OrdersResponseSuccess {
        __typename
        orders {
          ...OrderForLocation
          restaurant {
            ...OrderForLocationRestaurant
          }
        }
      }
    }
  }
  ${OrderForLocationFragmentDoc}
  ${OrderForLocationRestaurantFragmentDoc}
`;

export function useOrdersV2ForLocationQuery(
  options: Omit<Urql.UseQueryArgs<OrdersV2ForLocationQueryVariables>, 'query'>,
) {
  return Urql.useQuery<OrdersV2ForLocationQuery, OrdersV2ForLocationQueryVariables>({
    query: OrdersV2ForLocationDocument,
    ...options,
  });
}
export const OrdersV2ForLocationWithDisclosureDocument = gql`
  query ordersV2ForLocationWithDisclosure($input: OrdersInputV2!) {
    ordersV2(input: $input) {
      ... on OrdersResponseSuccess {
        __typename
        orders {
          ...OrderForLocation
          restaurant {
            ...OrderForLocationRestaurant
            showDeliveryPriceDifferenciationDisclosure
            showOutpostPriceDifferenciationDisclosure
          }
        }
      }
    }
  }
  ${OrderForLocationFragmentDoc}
  ${OrderForLocationRestaurantFragmentDoc}
`;

export function useOrdersV2ForLocationWithDisclosureQuery(
  options: Omit<Urql.UseQueryArgs<OrdersV2ForLocationWithDisclosureQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    OrdersV2ForLocationWithDisclosureQuery,
    OrdersV2ForLocationWithDisclosureQueryVariables
  >({ query: OrdersV2ForLocationWithDisclosureDocument, ...options });
}
